import IndustriesInput from './IndustriesInput'

export default IndustriesInput
